import { styled } from '@mui/material/styles';
import VoiceLeaderboardBgNewest from '@src/assets/images/start-bg.png';
import { BREAKPOINTS } from '@src/styles/config';

const StyledVoiceLeaderboardContainer = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  max-width: 1280px;
  padding: 0px;
  margin: 0 auto;
  position: relative;

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: -264px;
    left: 0;
    width: 100%;
    height: 500px;
    background-image: url(${VoiceLeaderboardBgNewest});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top center;
    z-index: 0;
    pointer-events: none;
  }

  > * {
    position: relative;
    z-index: 1;
  }
`;

const StyledHeaderContainer = styled('div')`
  display: flex;
  justify-content: center;
  padding-top: 0px;
  width: 100%;
  max-width: 1228px;
  margin: 0 auto;
  margin-bottom: 24px;
  @media (max-width: ${BREAKPOINTS.LMD}px) {
    .text-period-switcher,
    .text-tabs {
      font-size: 14px;
    }
    .tabs-description {
      width: max-content;
    }
  }
`;

const StyledPeriodSwitcher = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const StyledHeaderContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: 'center';

  @media (max-width: ${BREAKPOINTS.LMD}px) {
    .leaderboard-title {
      width: max-content;
      font-size: 40px;
    }
  }
`;

export {
  StyledVoiceLeaderboardContainer,
  StyledHeaderContainer,
  StyledPeriodSwitcher,
  StyledHeaderContent,
};
